<template>
  <div class="project-summary">
    <div class="section">
      <b-loading :active="isLoading"></b-loading>
      <div class="columns">
        <div class="column is-full">
          <div class="box">
            <div class="columns" style="margin-top: 16px">
              <div class="column">
                <header class="heading">
                  <p class="modal-card-title">{{ pageTitle }}
                    <router-link class="has-text-weight-bold" :to="{ name: 'ProjectDetails', params: { id:project_id }}">
                      {{ projectCode }}
                    </router-link>
                  </p>
                </header>
              </div>
              <div class="column is-narrow">
                <b-button class="button" @click="backClicked" tabindex="1" icon-left="arrow-left-bold">
                  {{ $t('common.back') }}
                </b-button>
              </div>
              <div v-if="this.currentUserAccess('ProjectLogs', UserActions.VIEW, this.project_id)"
                    class="column is-narrow">
                <b-button class="button" icon-left="eye">
                  <router-link :to="{ name: 'ProjectLogs', params: { project_id:this.project_id }}">
                    {{ $t('projects-view.enter-worklog') }}                
                  </router-link>
                </b-button>
              </div>
            </div>
            <b-tabs type="is-toggle">
              <b-tab-item :label="$t('project-summary-view.per-day-title')" icon="calendar">
                <div class="columns is-mobile" style="margin-top: 16px; height: 100%">
                  <div class="column is-5" style="overflow-y: auto; height: 800px;">
                    <GroupedLogs v-bind:project_id="this.project_id" @groupLogSelected="onGroupLogSelected"/>
                  </div>
                  <div class="column is-7" style="background: white; overflow-y: auto; height: 800px;">
                    <GroupedLogDetails v-bind:selected_grouped_log="this.selectedGroupedLog"/>
                  </div>
                </div>
              </b-tab-item>
              <b-tab-item :label="$t('project-summary-view.per-task-title')" icon="format-list-checks">
                <div class="columns is-mobile" style="margin-top: 16px; height: 100%">
                  <div class="column is-full" style="overflow-y: auto; height: 800px;">
                    <GroupedLogsPerTask v-bind:project_id="this.project_id"/>
                  </div>
                </div>
              </b-tab-item>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import firebase from "firebase/app";
import GroupedLogs from "@/components/GroupedLogs";
import GroupedLogDetails from "@/components/GroupedLogDetails";
import GroupedLogsPerTask from "@/components/GroupedLogsPerTask";

export default {
  name: "ProjectSummary",
  components: {
    GroupedLogs,
    GroupedLogDetails,
    GroupedLogsPerTask,
  },
  props: {
    'project_id': {
      type: String,
    }
  },
  data() {
    return {
      isLoading: false,
      projectCode: "",
      selectedGroupedLog: {
        grouped_log: {}
      }
    }
  },
  methods: {
    readProjectData: function () {
      this.isLoading = true
      const functions = firebase.app().functions("europe-west3");
      const getProjectFunction = functions.httpsCallable(this.getSubmitEndpoint());
      getProjectFunction({action: "get_project_by_id", document_id: this.project_id, fill_meta: true})
          .then((result) => {
            this.isLoading = false
            console.log("result get project by id: ", result.data);
            this.projectCode = result.data.projects.code;
          })
          .catch((error) => {
            this.isLoading = false;
            this.showError(error.message)
            if (error.message === "InvalidPath") {
              this.$router.replace("../projects");
            }
            console.log("Error getting project: ", error);
          });
    },
    onGroupLogSelected: function (groupLog) {
      this.selectedGroupedLog = groupLog
    },
    /*
     UI Events
     */
    backClicked: function () {
      this.$router.back()
    },
    worklogClicked: function () {
      this.$router.push({
        name: 'ProjectLogs',
        params: {
          project_id: this.project_id
        }
      })
    }
  },
  mounted() {
    if (!this.currentUserAccess("ProjectSummary", this.UserActions.VIEW, this.project_id)) {
      console.log("Page access denied.");
      this.$router.replace("/projects/").catch(() => {
      });
    }
    this.readProjectData();
  },
  computed: {
    pageTitle() {
      return this.$t('project-summary-view.title')
    }
  }
};
</script>

<style scoped>
</style>
